import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import routes from '.';
import { Auth } from '../pages';
import AuthGuard from './components/AuthGuard';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import PathConstants from './pathConstants';
import DownloadPage from '../pages/DownloadPage';
import PublicPage from '../pages/PublicPage';
import PublicNews from '../features/Gnn/components/PublicPage/PublicNews';
import VendorPage from '../features/teaAndSnacks/components/VendorPage';

const router = createBrowserRouter([
  // { path: '/download', element: <DownloadPage /> },
  {
    path: '/public',
    element: <PublicPage />
  },
  // { path: '/vendor', element: <VendorPage /> },
  {
    path: '/',
    element: <ProtectedRoute redirectPath="/auth" />,
    children: routes.LAYOUTS,
  },
  {
    path: '/auth',
    element: <PublicRoute redirectPath="/" />,
    children: [{ path: '/auth', element: <Auth /> }],
  },
  { path: '*', element: <Navigate to={'/auth'} /> },
],
// {basename:`/linkway-${process.env.REACT_APP_ENVIRONMENT}`}
);
const Router = () => {
  return <RouterProvider router={router} />;
};

export default Router;
